import React from 'react';

import { cn, iaRa } from 'lib/helpers/utility';

import { getProcedureName } from 'components/practice/charts/ClinicalNote/shared/CPTCodes/lib/helpers';

import OverflowChipList from './OverflowChipList/OverflowChipList';

const ProceduresCell = ({ data, node, procedureCodes, justify = 'center' }) => {
  const procedures = iaRa(data?.procedures);
  const finalProcedures =
    procedureCodes || procedures.map((procedure) => getProcedureName(procedure)).filter(Boolean);

  if (node?.group) return null;

  return (
    <div
      className={cn(
        'flex h-full min-w-0 items-center overflow-hidden',
        justify === 'start' ? 'justify-start' : 'justify-center'
      )}>
      <OverflowChipList items={finalProcedures} justify={justify} className="min-w-0" />
    </div>
  );
};

export default ProceduresCell;
